// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Project picker card — pairs with global .shadow-border-1; avoid overflow:hidden on the card (clips menus). */

.project-get-card .project-get-card__header {
  background: #fff;
  border-bottom: 1px solid #e9ecef;
  padding: 0.75rem 1rem;
}

.project-get-card .project-get-card__title {
  color: #2563eb;
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: -0.01em;
  gap: 0.5rem;
}

.project-get-card .project-get-card__body {
  padding: 1rem 1rem 1.125rem;
  background: #fff;
}

.project-get-card .project-get-card__label {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #6c757d;
  margin-bottom: 0.5rem;
}

/* react-select (classNamePrefix project-get-card-select) fine-tuning */
.project-get-card-select__control {
  cursor: text;
}

.project-get-card-select__menu {
  margin-top: 6px !important;
}

.project-get-card-select__menu-list {
  scrollbar-width: thin;
  scrollbar-color: #c1c9d2 #f1f3f5;
}

.project-get-card-select__menu-list::-webkit-scrollbar {
  width: 8px;
}

.project-get-card-select__menu-list::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 4px;
}

.project-get-card-select__menu-list::-webkit-scrollbar-thumb {
  background: #adb5bd;
  border-radius: 4px;
}

.project-get-card-select__loading-indicator {
  color: #2563eb;
}
`, "",{"version":3,"sources":["webpack://./src/components/projectgetcard.css"],"names":[],"mappings":"AAAA,+GAA+G;;AAE/G;EACE,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,uEAAuE;AACvE;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Project picker card — pairs with global .shadow-border-1; avoid overflow:hidden on the card (clips menus). */\n\n.project-get-card .project-get-card__header {\n  background: #fff;\n  border-bottom: 1px solid #e9ecef;\n  padding: 0.75rem 1rem;\n}\n\n.project-get-card .project-get-card__title {\n  color: #2563eb;\n  font-weight: 600;\n  font-size: 1rem;\n  letter-spacing: -0.01em;\n  gap: 0.5rem;\n}\n\n.project-get-card .project-get-card__body {\n  padding: 1rem 1rem 1.125rem;\n  background: #fff;\n}\n\n.project-get-card .project-get-card__label {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #6c757d;\n  margin-bottom: 0.5rem;\n}\n\n/* react-select (classNamePrefix project-get-card-select) fine-tuning */\n.project-get-card-select__control {\n  cursor: text;\n}\n\n.project-get-card-select__menu {\n  margin-top: 6px !important;\n}\n\n.project-get-card-select__menu-list {\n  scrollbar-width: thin;\n  scrollbar-color: #c1c9d2 #f1f3f5;\n}\n\n.project-get-card-select__menu-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.project-get-card-select__menu-list::-webkit-scrollbar-track {\n  background: #f1f3f5;\n  border-radius: 4px;\n}\n\n.project-get-card-select__menu-list::-webkit-scrollbar-thumb {\n  background: #adb5bd;\n  border-radius: 4px;\n}\n\n.project-get-card-select__loading-indicator {\n  color: #2563eb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
